import { useContext } from 'react';
import { TetrisThemeContext } from './Provider';
export const useTetrisTheme = () => {
    const context = useContext(TetrisThemeContext);
    if (!context) {
        throw new Error('useTetrisTheme was used outside of the TetrisThemeContext');
    }
    return context;
};
